import { render, staticRenderFns } from "./EmpresaView.vue?vue&type=template&id=45736a2e&scoped=true"
import script from "./EmpresaView.vue?vue&type=script&lang=js"
export * from "./EmpresaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45736a2e",
  null
  
)

export default component.exports